// src/components/RenameDatasetModal.tsx
import React, { useEffect } from "react";
import { Modal, Form, Input } from "antd";

type Props = {
  open: boolean;
  dataset?: { id: number; name: string } | null;
  confirmLoading?: boolean;
  onCancel: () => void;
  onSubmit: (name: string) => void;
};

const RenameDatasetModal: React.FC<Props> = ({ open, dataset, confirmLoading, onCancel, onSubmit }) => {
  const [form] = Form.useForm<{ name: string }>();

  useEffect(() => {
    form.setFieldsValue({ name: dataset?.name || "" });
  }, [dataset, form]);

  return (
    <Modal
      open={open}
      title="Rename Dataset"
      okText="Save"
      onOk={() => form.submit()}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      width={520}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={(vals) => onSubmit(vals.name.trim())}
      >
        <Form.Item
          label="New name"
          name="name"
          rules={[
            { required: true, message: "Please enter a name" },
            { min: 3, message: "At least 3 characters" },
            { max: 120, message: "Max 120 characters" },
          ]}
        >
          <Input placeholder="Enter dataset name" autoFocus />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RenameDatasetModal;
